module.exports = __webpack_public_path__ + "static/media/bomb-money.24315548.png";